import { useParams } from "react-router"

import { ErrorPage } from "@/components/System"
import { HistoryDetail } from "@/components/History"

const HistoryPage = () => {
  const { historyId: historyIdParam } = useParams()
  const parsedHistoryId = Number.parseInt(historyIdParam ?? "", 10)

  if (Number.isNaN(parsedHistoryId)) {
    return <ErrorPage showButton={false} />
  }

  return (
    <HistoryDetail
      key={parsedHistoryId}
      historyId={parsedHistoryId}
      mode="standalone"
    />
  )
}

export default HistoryPage
